import { inject, Injectable } from "@angular/core";

import { evaluate } from "mathjs";

import {
    HtmlContext,
    HtmlSequence,
    HtmlDirective,
    HtmlDirectiveEvaluator,
    HtmlDirectiveEvaluatorSettings,
} from "@main/reporting.v3/widget.html/models";
import {
    HtmlBaseExpressionsArgumentService
} from "@main/reporting.v3/widget.html/services/html-expressions/html-base-expressions-argument.service";


@Injectable()
export class HtmlEvalDirectiveService implements HtmlDirectiveEvaluator {

    private argumentService: HtmlBaseExpressionsArgumentService = inject(HtmlBaseExpressionsArgumentService);

    public readonly directive: string = "eval";

    public async evaluate(directive: HtmlDirective, settings: HtmlDirectiveEvaluatorSettings): Promise<any> {
        if (!directive || directive.name !== this.directive || !settings) return null;

        const arg: HtmlSequence = directive.arguments[0];
        const param: any = await this.argumentService.evaluate(arg, settings);
        const expression: string = this.argumentService.toString(param);

        // Ensure eval expression is passed and it is valid.
        if (!expression?.length) return null;

        return this.eval(settings.context, expression);
    }

    public async eval(context: HtmlContext, expression: string): Promise<any> {
        try {
            if (!context || !expression?.length) return null;

            // Avoid exceptions if the expression is not valid.
            return evaluate(expression) ?? null;

        } catch (error) {
            return null;
        }
    }
}